import { makeSelectors } from '@utils/css';

const inputWrapper = "dibixpj03p";
const input = "dibi1eewa6u";
const pencil = "dibp1fbwspi";
const editInputSelectors = makeSelectors({
  input,
  pencil
});

export { editInputSelectors, input, inputWrapper, pencil };
import "./edit-input.style.linaria.module.css";
//# sourceMappingURL=edit-input.style.js.map
